// extracted by mini-css-extract-plugin
module.exports = {"gameBackground":"c"};